import React, { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import axios from "axios";
import Loader from "../loader/Loader";
import { useDispatch } from "react-redux";
import { set_audit_status as setAuditStatusRedux } from "../store/images";
import ExpiredStatus from "./ExpiredStatus";
import SuccessComponent from "../audit-completion-module/SuccessComponent";
import moment from "moment";

const ProtectedRoute = ({ element: Component }) => {
  const dispatch = useDispatch();
  const { audit_id } = useParams();
  const [isValid, setIsValid] = useState(null);
  const [loading, setLoading] = useState(true);
  const [audit_status, setAuditStatus] = useState(null);   
  
  const styles = {
    container: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100svh",
      backgroundColor: "#ffffff",
    },
    image: {
      maxWidth: "90vw",
      maxHeight: "90vh",
      width: "auto",
      height: "auto",
      animation: "fadeInOut 4s ease-in-out infinite, pulse 2s ease-in-out infinite",
    },
  };

  const not_found = `${process.env.PUBLIC_URL}/inspection-images/not_found.png`;

  useEffect(() => {
    const checkTokenValidity = async () => {
      try {
        const res = await axios.post("/create_audit/verify_token", { audit: audit_id, processed: 0,inspection_time:moment().format("DD-MM-YYYY HH:mm") });
        console.log(res);
        dispatch(setAuditStatusRedux(res.data)); // Redux action
        setAuditStatus(res.data); // Local state
        setIsValid(true);
      } catch (err) {
        console.error("Error", err.response?.data || err.message);
        setIsValid(false);
      } finally {
        setLoading(false);
      }
    };

    checkTokenValidity();
  }, [audit_id, dispatch]);

  if (loading) {
    return <Loader />;
  }

  if (audit_status === "Expired !") {
    return <ExpiredStatus />;
  }

  if (audit_status === "Audit not Found !") {
    return <div style={styles.container}> <img src={not_found} alt="not_found" style={styles.image} /></div> 
  }

  if (audit_status === "Success !") {
    return <Component />;
  }
  if(audit_status === "Already Completed !"){
    return <SuccessComponent />
  }

  return isValid ? <Component /> : <Navigate to="/no-access" />;
};

export default ProtectedRoute;
